module.exports = __webpack_public_path__ + "public/Icons/tracking.svg?cd88867f";